export default __webpack_public_path__ + "static/media/drop.28d23717.svg";